var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{class:_vm.getRowClass(_vm.rowData)},_vm._l((_vm.tableColumns),function(columnDetails,id){return _c('th',{class:columnDetails.cellClass},[_vm._t("default"),_vm._v(_vm._s(columnDetails.cellData))],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }